export default __webpack_public_path__ + "static/262-f8a4784a4d0b5a191c147862fbd852e1.gif";